import { H4 } from '@linearb/linui-common/typography';
import { Stack } from '@mui/material';
import { lightColorPalette } from '@linearb/linui-common';
import useUserProfile from 'views/root/views/home/hooks/useUserProfile';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';
import { STEPS_ORDER } from './Steps/steps.consts';
import { LBButton } from '@linearb/buzz';
import Icon from 'components/base/Icon';

interface HeaderProps {
  setOpenWizard: (value: boolean) => void;
  userName?: string;
  setOpenSnoozeSnackBar: (value: boolean) => void;
}

function Header({
  setOpenWizard,
  userName = '',
  setOpenSnoozeSnackBar
}: HeaderProps): JSX.Element {
  const { onSave, userProfileDBData, accountId, orgId } = useUserProfile();

  const currentStep = STEPS_ORDER.indexOf(userProfileDBData?.currentStep);
  const indexOfCurrentStep = currentStep === -1 ? 0 : currentStep;

  const handleClose = () => {
    const today = new Date();
    onSave({ snoozeWizardTill: new Date(today.setDate(today.getDate() + 7)) });
    TrackingService.logEvent(TRACKING.EVENTS.USER_PROFILE.EVENT, {
      event_type: TRACKING.EVENTS.USER_PROFILE.EVENT_TYPE.CLOSE,
      user_id: accountId,
      org_id: orgId,
      closed_on: STEPS_ORDER[indexOfCurrentStep]
    });
    setOpenSnoozeSnackBar(true && !userProfileDBData?.doNotShowAgain);
    setOpenWizard(false);
  };

  return (
    <Stack
      direction={'row'}
      sx={{ justifyContent: 'space-between', alignItems: 'center' }}
      data-cy='user-profile-header'
    >
      <H4 color={lightColorPalette.lbGreyDark}>
        Hi <strong>{userName}</strong>, Complete Your User Profile
      </H4>
      <LBButton
        variant='ghost'
        size='icon'
        onClick={handleClose}
        data-cy='close-user-profile-btn'
      >
        <Icon name='close' size='small' />
      </LBButton>
    </Stack>
  );
}

export default Header;
